import React, { Component } from 'react';
import moment from 'moment';

import { Form, Input, Button, Modal, Radio, Divider, Switch, DatePicker } from 'antd';
import SignView from './SignView';
import { withState } from 'recompose';
const FormItem = Form.Item;


class ParkinglocationPriorityMsgForm extends Component {

  state = {
    modalVisible: false,
    PriorityMessageValue: 'null',
    PriorityMsgFrom: moment().startOf('day'),
    PriorityMsgTo: moment().endOf('day')
  }

  form = null;

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible,
    });
  }

  onDateRangeChanged(dates) {
    this.setState({
      PriorityMsgFrom: dates[0],
      PriorityMsgTo: dates[1]
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (values.range) {
          let now = moment().utc().format('YYYY-MM-DDTHH:mm:00Z');
          // when PriorityMsgFrom is older then now it is set to now+1 minutes
          values.PriorityMsgFrom = values.range[0] && moment(values.range[0]).utc().format('YYYY-MM-DDTHH:mm:00Z') <= now ? moment(now).add(1, 'minutes').utc().format('YYYY-MM-DDTHH:mm:00Z') : moment(values.range[0]).utc().format('YYYY-MM-DDTHH:mm:00Z');
          values.PriorityMsgTo = values.range[1] && moment(values.range[1]).utc().format('YYYY-MM-DDTHH:mm:00Z');
        }
        if (values.PriorityMessage == 'null') {
          values.PriorityMessage = null;
          values.PriorityMsgFrom = null;
          values.PriorityMsgTo = null;
          values.PriorityMessageOwn = null;
        }
        if (values.PriorityMessageOwn) {
          values.PriorityMessage = values.PriorityMessageOwn;
        }
        delete values.range;

        this.props.onSuccess(this.props.form, values);
      }
    });
  }
  onChangePriorityMsg = e => {
    this.setState({
      PriorityMessageValue: e.target.value,
    });
  };

  renderForm() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    const fullFormItemLayout = {
      labelCol: {
        xs: { span: 0 },
        sm: { span: 0 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
    };
    const radioStyle = {
      display: 'block',
      height: '45px',
      lineHeight: '40px',
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          label="Prioritní zpráva"
          {...formItemLayout}
        >
          {getFieldDecorator('PriorityMessage', {
            initialValue: this.props.initialValues && this.props.initialValues.PriorityMessage && this.props.initialValues.PriorityMessage != '' && !this.props.initialValues.PriorityMessageOwn
              ? this.props.initialValues.PriorityMessage
              : this.props.initialValues && this.props.initialValues.PriorityMessageOwn ? 'own' : 'null',
          })(
            <Radio.Group onChange={this.onChangePriorityMsg} setFieldsValue={this.state.PriorityMessageValue}>
              <Radio style={radioStyle} value={'null'}>
                BEZ PRIORITNÍ ZPRÁVY
              </Radio>
              <Radio style={radioStyle} value={'UZAVŘENO'}>
                <SignView text={'UZAVŘENO'} color={'white'} background={'black'} width={120} textAlign={'center'} />
              </Radio>
              <Radio style={radioStyle} value={"\\GVOLNO"}>
                <SignView text={'VOLNO'} color={'lightgreen'} background={'black'} width={120} textAlign={'center'} />
              </Radio>
              <Radio style={radioStyle} value={'\\ROBSAZENO'}>
                <SignView text={'OBSAZENO'} color={'red'} background={'black'} width={120} textAlign={'center'} />
              </Radio>
              <Radio style={radioStyle} value={'own'}>
                Vlastní...
                {this.state.PriorityMessageValue === 'own' || this.props.initialValues && this.props.initialValues.PriorityMessageOwn ?
                  <FormItem>
                    {getFieldDecorator('PriorityMessageOwn', {
                      initialValue: this.props.initialValues && this.props.initialValues.PriorityMessageOwn ? this.props.initialValues.PriorityMessageOwn : null,
                      rules: [
                        { required: true, message: "Vyplňte vlastní Prioritní zprávu" },
                        { max: 10, message: "Prioritní zpráva musí mít maximálně 10 znaků!" },
                      ]
                    })(<Input style={{ width: 200, marginLeft: 10 }} />)}
                  </FormItem>
                  : null}
              </Radio>
            </Radio.Group>
          )}
        </FormItem>
        <FormItem
          label="Platnost prioritní zprávy"
          {...formItemLayout}
        >
          {getFieldDecorator('range', {
            rules: this.state.PriorityMessageValue !== 'null' && [
              {
                required: true, message: "Vyplňte vlastní platnost pro Prioritní zprávu",
              },
            ],
            initialValue: (this.props.initialValues && this.props.initialValues.PriorityMsgFrom && this.props.initialValues.PriorityMsgTo) && [
              moment(this.props.initialValues.PriorityMsgFrom),
              moment(this.props.initialValues.PriorityMsgTo)
            ]
          })(
            <DatePicker.RangePicker
              ranges={{
                "Dnes": [moment().add(1, 'minutes'), moment().endOf('day')],
                "Zítra": [moment().add(1, 'days').startOf('day'), moment().add(1, 'days').endOf('day')],
                "7 dnů": [moment().add(1, 'minutes'), moment().add(7, 'days').endOf('day')],
              }}
              allowClear={false}
              //placeholder={['Od', 'Do']}
              format="DD.MM.YYYY HH:mm"
              showTime={{ format: 'HH:mm' }}
              //onOk={this.onDateRangeChanged.bind(this)}
              style={{ width: 400 }}
            />
          )}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">Uložit</Button>
        </FormItem>
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          width={700}
          title="Nastavení prioritní zprávy"
          visible={this.state.modalVisible}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
        >
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedParkinglocationPriorMsgForm = Form.create()(ParkinglocationPriorityMsgForm);

export default WrappedParkinglocationPriorMsgForm;


// WEBPACK FOOTER //
// ./src/components/ParkinglocationPriorityMsgForm.js